import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import ResourceFormButton from "../components/ResourceFormButton";
import LDAPTestButton from "../components/LDAPTestButton";
import DeleteResourceButton from "../components/DeleteResourceButton";
import { Renderer } from "./common";
import { FormattedMessage } from "react-intl";

const ldapAuthRenderers: Record<string, Renderer> = {
    use_ssl: (val, data) => {
        // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
        let icon = val ? (
            <FontAwesomeIcon icon={faCheck} color="green" />
        ) : (
            <FontAwesomeIcon icon={faTimes} color="red" />
        );
        return icon;
    },
    directory_type: (val, data) => {
        // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
        return <FormattedMessage id={"ldap_auth.directory_types." + val} />;
    },
    controlHeaderCell: (val, data) => {
        return (
            <div>
                <ResourceFormButton
                    resourceName="ldap_auth"
                    action="update"
                    id={data.id}
                    size="medium"
                    buttonType="icon"
                    extraButtons={[LDAPTestButton]}
                />{" "}
                <DeleteResourceButton id={data.id} resourceName="ldap_auth" />
            </div>
        );
    },
};

export default ldapAuthRenderers;
